<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ student?: { free_mode?: boolean }; mode?: string; primary?: boolean }>()
defineEmits<{ (e: 'change-mode'): void }>()

const ctxMode = computed(() => {
  if (props.mode) return props.mode
  if (props.student?.free_mode) return 'free'
  return 'auto'
})

const color = computed(() => {
  if (props.primary) return 'primary'
  switch (ctxMode.value) {
    case 'teacher':
      return 'blue'
    case 'auto':
      return 'green'
    case 'free':
      return 'red'
    default:
      return 'blue'
  }
})
</script>

<template>
  <div class="student-mode-badge" :class="`student-mode-badge_color_${color}`" @click="() => $emit('change-mode')">
    <template v-if="ctxMode === 'teacher'">
      <v-icon size="20">mdi-school</v-icon>
    </template>
    <template v-if="ctxMode === 'auto'">Auto</template>
    <template v-if="ctxMode === 'free'">
      Free
      <v-icon size="20">mdi-alert-circle-outline</v-icon>
    </template>
  </div>
</template>

<style lang="scss">
@use '~/styles/pages/student2/screen' as s2;

.student-mode-badge {
  min-width: 56px;
  height: 28px;
  padding: 4px;
  border-radius: 8px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;

  cursor: pointer;

  font-size: 14px;
  font-weight: 400;
  line-height: 24px;

  @include s2.mobile {
    min-width: 48px;
  }

  border: 1px solid;

  &_color {
    &_blue {
      background: $lightenBlue;
      border-color: $lightBlue;
    }
    &_green {
      background: $lightenGreen;
      border-color: $lightGreen;
    }
    &_red {
      background: $lightenRed;
      border-color: $lightRed;
    }
    &_primary {
      background: $blue;
      color: white;
    }
  }
}
</style>
